import { message } from 'antd'
import { unomit } from '../../../HttpRequests/planner'
import fetch from './fetch'
import handleException from '../../../Core/Helpers/handleException'

export default (projectId) => async (dispatch) => {

  try {

    await unomit({ projectId })

    message.success(`Subscribed to project "${projectId}"`)

    dispatch(fetch())

  } catch (error) {

    handleException(error)

  }

}
